import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[outerFocus]'
})
export class OuterFocusDirective {

  constructor(private el: ElementRef) { }

  @Input('outerFocus') target: any;

  @HostListener('focus') onFocus() {
    this.target.classList.add('focus');
  }

  @HostListener('focusout') onFocusOut() {
    this.target.classList.remove('focus');
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/directives/outer-focus.directive.ts